// extracted by mini-css-extract-plugin
export default {"image-avatar":"ImageObject_image-avatar__1ZYeR","loading":"ImageObject_loading__FXhZ+"};